/** @param {unknown} value */
function valueActive(value) {
  if (Array.isArray(value)) return value.length > 0
  return value !== '' && value !== null && value !== undefined
}

/** @param {unknown} a @param {unknown} b */
function valuesEqual(a, b) {
  if (Array.isArray(a) || Array.isArray(b)) {
    const left = Array.isArray(a) ? a : []
    const right = Array.isArray(b) ? b : []
    if (left.length !== right.length) return false
    return left.every((row, index) => String(row?.id ?? '') === String(right[index]?.id ?? ''))
  }
  return a === b
}

function bagHas(bag) {
  return Object.values(bag).some(valueActive)
}

function bagsSame(a, b) {
  for (const key of Object.keys(a)) {
    if (!valuesEqual(a[key], b[key])) return false
  }
  return true
}

/** @param {{ id?: string }[]|null|undefined} rows */
function pickerIds(rows) {
  return (rows ?? []).map((row) => String(row?.id ?? '')).filter(Boolean)
}

class FilterUtility {
  /** @param {Record<string, unknown>} bag */
  has(bag) {
    return bagHas(bag)
  }

  /** @param {Record<string, unknown>} a @param {Record<string, unknown>} b */
  same(a, b) {
    return bagsSame(a, b)
  }

  /** Snapshot ids from scroll-search multi pickers (`{ id, name }[]`). */
  pickerIds(rows) {
    return pickerIds(rows)
  }
}

export default new FilterUtility()
